import React from 'react';
import { Tooltip } from 'react-tooltip'
const CrewCartMember = ({ name, status, size, showFullName=false }) => {
    const getInitials = (name) => {
        const nameArray = name.trim().split(/\s+/);  // Split by spaces and remove extra spaces

        if (nameArray.length === 1) {
            return nameArray[0].charAt(0).toUpperCase();  // Return first letter if only one name
        }

        const firstInitial = nameArray[0].charAt(0).toUpperCase();  // First name initial
        const lastInitial = nameArray[nameArray.length - 1].charAt(0).toUpperCase();  // Last name initial

        return `${firstInitial}${lastInitial}`;
    };


    const toCamelCase = (str) => {
        return str
            .toLowerCase()
            .replace(/(?:^\w|[A-Z]|\b\w)/g, (match, index) =>
                index === 0 ? match.toUpperCase() : match.toLowerCase()
            )
            .replace(/\s+/g, '');
    };

    const formattedStatus = toCamelCase(status);

    const initials = getInitials(name);

    const getStatusColor = (status) => {
        switch (status) {
            case 'SHOPPING':
                return '#ffac27';
            case 'IDLE':
                return '#dc2626';
            case 'DONE':
                return '#22c55e';
            default:
                return '#9ca3af';
        }
    };

    const statusColor = getStatusColor(status);

    return (
        <>
            <style>
                {`

                    .crew-member-avatar {
                        width: ${size}px;
                        height: ${size}px;
                        background-color: #1f2937;
                        border-radius: 9999px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        color: white;
                        font-weight: bold;
                        position: relative;
                        margin-right: -3px;
                        border: 1px solid white;
                        display:inline-block;
                    }

                    .crew-member-initials {
    font-size: calc(${size}px * 0.50);
    line-height: 1;  /* Changed from calculated value */
    font-weight: normal;
    margin: 0;  /* Remove default paragraph margin */
    padding: 0;  /* Remove any padding */
    display: flex;  /* Make it a flex container */
    align-items: center;  /* Center vertically */
    justify-content: center;  /* Center horizontally */
    height: 100%;  /* Take full height of parent */
}

                    .crew-member-status {
                        position: absolute;
                        bottom: 0;
                        right: 0;
                        width: calc(${size}px / 3.3);
                        height: calc(${size}px / 3.3);
                        border-radius: 9999px;
                        border: 2px solid white;
                    }
                `}
            </style>

            <Tooltip
                id={`tooltip-${name}`}
                place="top"
                effect="solid"
            />

            <div
                className="crew-member-avatar flex flex-row items-center justify-center relative"
                data-tooltip-id={`tooltip-${name}`}
                data-tooltip-html={`<div style="text-align: center;"><strong>${name}</strong><br />${formattedStatus}</div>`}
            >
                    <p className="crew-member-initials">{initials}</p>
                    <div
                        className="crew-member-status"
                        style={{backgroundColor: statusColor}}
                    />
                </div>
                {showFullName ? <span style={{width: "200px", marginLeft: "10px"}}>{name}</span> : ""}
            </>
            );
            };

            export default CrewCartMember;
